var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLegalForms(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 4,
    fill: "#6B92DC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4_6599",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 4,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4_6599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.3 34.7666H8.7C7.79333 34.7666 7 35.5033 7 36.4666C7 37.3733 7.73667 38.1666 8.7 38.1666H39.3C40.2067 38.1666 41 37.4299 41 36.4666C41 35.5033 40.2633 34.7666 39.3 34.7666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.26667 31.3663H28.5333V29.0997C28.5333 28.4763 29.0433 27.9663 29.6667 27.9663H35.3333C35.9567 27.9663 36.4667 28.4763 36.4667 29.0997V31.3663H38.7333C39.3567 31.3663 39.8667 30.8563 39.8667 30.233V10.9663C39.8667 10.343 39.3567 9.83301 38.7333 9.83301H9.26667C8.64333 9.83301 8.13333 10.343 8.13333 10.9663V30.233C8.13333 30.8563 8.64333 31.3663 9.26667 31.3663ZM14.3667 16.633C14.3667 16.0097 14.8767 15.4997 15.5 15.4997H31.9333C32.5567 15.4997 33.0667 16.0097 33.0667 16.633V17.7663C33.0667 18.3897 32.5567 18.8997 31.9333 18.8997H15.5C14.8767 18.8997 14.3667 18.3897 14.3667 17.7663V16.633ZM15.5 22.2997C14.8767 22.2997 14.3667 22.8097 14.3667 23.433V24.5663C14.3667 25.1897 14.8767 25.6997 15.5 25.6997H26.2667C26.89 25.6997 27.4 25.1897 27.4 24.5663V23.433C27.4 22.8097 26.89 22.2997 26.2667 22.2997H15.5Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalForms);
export default __webpack_public_path__ + "static/media/legal_forms.9cdd1d243728e1a7bbff88d7acda04f7.svg";
export { ForwardRef as ReactComponent };